import { useEffect, useState } from 'react';
import { cloneDeep, isEmpty } from 'lodash';
import { toast } from 'material-react-toastify';
import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  TextField,
  Typography,
} from '@mui/material';
import { getEmptyMenu, Menu } from '../../interfaces/Menu/Menu';
import { createMenu, updateMenu } from '../../api/Menu';
import { Waiting } from '../../components/Waiting/Waiting';
import { sharedColors, sharedStyles } from '../../utils/Style';

type UpsertMenuDialogProps = {
  open: boolean;
  onUpsert: () => void;
  onClose: () => void;
  clickedMenu?: Menu;
};

export const UpsertMenuDialog = (props: UpsertMenuDialogProps) => {
  const [loading, setLoading] = useState(false);
  const [currentState, setCurrentState] = useState(getEmptyMenu());

  const isEditing = !!props.clickedMenu;

  useEffect(() => {
    setCurrentState(
      props.clickedMenu ? cloneDeep(props.clickedMenu) : getEmptyMenu(),
    );
  }, [props.clickedMenu]);

  const handleConfirm = () => {
    setLoading(true);
    if (isEditing) {
      updateMenu(currentState)
        .then(() => {
          toast.success('Menü başarıyla güncellendi');
          props.onUpsert();
        })
        .catch((err) => toast.error(err.message))
        .finally(() => setLoading(false));
    } else {
      createMenu(currentState)
        .then(() => {
          toast.success('Menü başarıyla oluşturuldu');
          props.onUpsert();
        })
        .catch((err) => toast.error(err.message))
        .finally(() => setLoading(false));
    }
  };

  const validState = !isEmpty(currentState.name);

  return (
    <Dialog open={props.open} onClose={props.onClose}>
      <Waiting open={loading} />
      <DialogTitle sx={{ ...sharedStyles.h6, color: sharedColors.gray6 }}>
        {isEditing ? 'Menüyü Düzenle' : 'Yeni Menü'}
      </DialogTitle>
      <DialogContent sx={{ display: 'flex', flexDirection: 'column' }}>
        <TextField
          label='Değer'
          value={currentState.name}
          onChange={(e) =>
            setCurrentState({ ...currentState, name: e.target.value })
          }
          size='small'
          error={isEmpty(currentState.name)}
          sx={{ width: 350, mt: 1.5 }}
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={currentState.isActive}
              onChange={() =>
                setCurrentState({
                  ...currentState,
                  isActive: !currentState.isActive,
                })
              }
            />
          }
          label={<Typography sx={sharedStyles.subtitle2}>Aktif</Typography>}
        />
      </DialogContent>
      <DialogActions sx={{ px: 2.5, pb: 1.5 }}>
        <Button
          variant='contained'
          color='inherit'
          onClick={props.onClose}
          sx={sharedStyles.buttonText}
        >
          İptal
        </Button>
        <Button
          variant='contained'
          color='primary'
          disabled={!validState}
          onClick={handleConfirm}
          sx={sharedStyles.buttonText}
        >
          Onayla
        </Button>
      </DialogActions>
    </Dialog>
  );
};
